/* eslint-disable */
export default {
  download: '다운로드',
  play: '재생',
  pause: '일시 중지',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
